<template>
  <div class="ancv-loader-row">
    <div class="ancv-cart-icon" />
    <div class="ancv-ellipse ancv-ellipse-1" />
    <div class="ancv-ellipse ancv-ellipse-2" />
    <div class="ancv-ellipse ancv-ellipse-3" />
    <div class="ancv-ellipse ancv-ellipse-4" />
    <div class="ancv-ellipse ancv-ellipse-5" />
    <div class="ancv-loader-logo" />
  </div>
</template>

<script>
export default {
    name: 'AncvLoader'
}
</script>

<style scoped>
.ancv-loader-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
	width: 100%;
	padding: 0 12px;
}

.ancv-ellipses {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    flex: 1;
}

.ancv-cart-icon {
    width: 144px;
    height: 87px;
    background: url('../assets/images/ancv-loader/ancv-cart-icon.svg') no-repeat center;
    background-size: contain;
}

.ancv-ellipse {
    width: 20px;
    height: 20px;
    background: url('../assets/images/ancv-loader/ancv-elipse-gray.svg') no-repeat center;
    background-size: contain;
}

/* Animation: 8 steps total (1→2→3→4→5→4→3→2), 1 second each = 8 seconds cycle */
.ancv-ellipse-1 { animation: ellipseBounce1 8s infinite; }
.ancv-ellipse-2 { animation: ellipseBounce2 8s infinite; }
.ancv-ellipse-3 { animation: ellipseBounce3 8s infinite; }
.ancv-ellipse-4 { animation: ellipseBounce4 8s infinite; }
.ancv-ellipse-5 { animation: ellipseBounce5 8s infinite; }

@keyframes ellipseBounce1 {
    0%, 12.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    12.5%, 87.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    87.5%, 100% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
}

@keyframes ellipseBounce2 {
    0%, 12.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    12.5%, 25% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    25%, 75% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    75%, 87.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    87.5%, 100% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
}

@keyframes ellipseBounce3 {
    0%, 25% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    25%, 37.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    37.5%, 62.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    62.5%, 75% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    75%, 100% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
}

@keyframes ellipseBounce4 {
    0%, 37.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    37.5%, 50% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    50%, 62.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    62.5%, 75% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    75%, 100% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
}

@keyframes ellipseBounce5 {
    0%, 50% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
    50%, 62.5% { background-image: url('../assets/images/ancv-loader/ancv-elipse-full.svg'); }
    62.5%, 100% { background-image: url('../assets/images/ancv-loader/ancv-elipse-gray.svg'); }
}

.ancv-loader-logo {
    width: 144px;
    height: 87px;
    background: url('../assets/images/ancv-loader/ancv-logo.svg') no-repeat center;
    background-size: contain;
}
</style>

